/* tslint:disable */
/* eslint-disable */
/**
 * NN.CustomerPortal.ApiApp.General
 * GeneralAPIs
 *
 * The version of the OpenAPI document: 1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DocumentDownloadResponse } from './DocumentDownloadResponse';
import {
    DocumentDownloadResponseFromJSON,
    DocumentDownloadResponseFromJSONTyped,
    DocumentDownloadResponseToJSON,
    DocumentDownloadResponseToJSONTyped,
} from './DocumentDownloadResponse';
import type { FileDownloadInfo } from './FileDownloadInfo';
import {
    FileDownloadInfoFromJSON,
    FileDownloadInfoFromJSONTyped,
    FileDownloadInfoToJSON,
    FileDownloadInfoToJSONTyped,
} from './FileDownloadInfo';

/**
 * 
 * @export
 * @interface ChangeAdditionalData
 */
export interface ChangeAdditionalData {
    /**
     * 
     * @type {FileDownloadInfo}
     * @memberof ChangeAdditionalData
     */
    dpsPrecontractualInfo: FileDownloadInfo;
    /**
     * 
     * @type {DocumentDownloadResponse}
     * @memberof ChangeAdditionalData
     */
    zzjDocumentInfo?: DocumentDownloadResponse;
}

/**
 * Check if a given object implements the ChangeAdditionalData interface.
 */
export function instanceOfChangeAdditionalData(value: object): value is ChangeAdditionalData {
    if (!('dpsPrecontractualInfo' in value) || value['dpsPrecontractualInfo'] === undefined) return false;
    return true;
}

export function ChangeAdditionalDataFromJSON(json: any): ChangeAdditionalData {
    return ChangeAdditionalDataFromJSONTyped(json, false);
}

export function ChangeAdditionalDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChangeAdditionalData {
    if (json == null) {
        return json;
    }
    return {
        
        'dpsPrecontractualInfo': FileDownloadInfoFromJSON(json['dpsPrecontractualInfo']),
        'zzjDocumentInfo': json['zzjDocumentInfo'] == null ? undefined : DocumentDownloadResponseFromJSON(json['zzjDocumentInfo']),
    };
}

export function ChangeAdditionalDataToJSON(json: any): ChangeAdditionalData {
    return ChangeAdditionalDataToJSONTyped(json, false);
}

export function ChangeAdditionalDataToJSONTyped(value?: ChangeAdditionalData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'dpsPrecontractualInfo': FileDownloadInfoToJSON(value['dpsPrecontractualInfo']),
        'zzjDocumentInfo': DocumentDownloadResponseToJSON(value['zzjDocumentInfo']),
    };
}

